import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  Container,
  Paper,
  Typography,
  Button,
  Box,
  Alert
} from '@mui/material';

const Unauthorized = () => {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut();
      navigate('/login');
    } catch (error) {
      console.error('Failed to log out', error);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Alert severity="error" sx={{ mb: 3 }}>
          Access Denied
        </Alert>
        <Typography variant="h5" component="h1" gutterBottom>
          Unauthorized Access
        </Typography>
        <Typography variant="body1" paragraph>
          You do not have the necessary permissions to access the admin panel.
          This area is restricted to administrators only.
        </Typography>
        <Typography variant="body1" paragraph>
          If you believe you should have access, please contact the system administrator.
        </Typography>
        <Box sx={{ mt: 3 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleLogout}
            fullWidth
          >
            Back to Login
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default Unauthorized;